export class API {
  static login = "api/login";
  static getPositionTreeView = "api/organization/position-tree";
  static getMasters = "api/getMasters";
  static getNewOTP = "api/auth/session/otp";
  static changePassword = "api/changePassword";
  static getUserSessions = "api/getUserSessions";
  static getUserLogs = "api/getUserLogs";
  static getActualTourPlan = "api/plans/tours/actual";
  static getTourPlan = "api/plans/tours/list";
  static getTeamAttendance = "api/reports/attendance/team";
  static getAllowedMonths = "api/config/allowed-months";
  static getEffortReport = "api/getEffortReport";
  static getDarReport = "api/getDarReport";
  static getMasReport = "api/getMasReport";
  static getOvpReport = "api/getOvpReport";
  static sendPushNotification = "api/sendPushNotification";
  static getEmployeeInfo = "api/getEmployeeInfo";
  static UpdateEmployeeDetails = "api/UpdateEmployeeDetails";
  static unlockAccount = "api/UnlockEmpAccount";
  static UnlockDays = "api/plans/tours/unlock";
  static getEmployeeAttendance = "api/getEmployeeAttendance";
  static getEmployees = "api/getEmployees";
  static getFtpImportBatches = "api/getFtpImportBatches";
  static getFtpExportBatches = "api/getFtpExportBatches";
  static getFtpImportLogs = "api/getFtpImportLogs";
  static getFtpExportLogs = "api/getFtpExportLogs";
  static getActivityKpis = "api/kpis/activities";
  static getTeamMtpStatus = "api/reports/mtp/team-status";
  static getRequestedMTPByPosition = "api/plans/mtp/requests";
  static getMtpByIdV2 = "api/plans/mtp/ById";
  static approveMTP = "api/plans/mtp/approve";
  static rejectMTP = "api/plans/mtp/reject";
  static pendingLeaveCountList = "api/leaves/requests/pending";
  static getEmployeeLeave = "api/leaves";
  static getLeaveStatus = "api/leaves/statuses";
  static leaveApprove = "api/leaves/approve";
  static leaveReject = "api/leaves/reject";
  static getMyTeam = "api/users/me/team";
  static expenseOverview = "api/expenses/overview";
  static empDateWiseExpense = "report/empDateWiseExpense";
  static getExpensesNew = "api/expenses/list";
  static getStatus = "api/system/status";
  static getExpensesMaster = "api/expenses/master-data";
  static editApprovalExpenses = "api/editApprovelExpenses";
  static getWorkingDays = "api/attendance/working-days";
  static expensesApproved = "api/expenses/status/approved";
  static deleteExpenseList = "api/expenses/delete";
  static getExpenseListDetails = "api/expenses/line-items";
  static getExpenseLastDates = "api/expenses/submission/due-dates";
  static getProfile = "api/users/me";
  static getSGPIBalance = "api/sgpi/balance";
  static getOutletTypes = "api/outlets/types";
  static getEmployeeLeave = "api/leaves";
  static getEmployeeLeaveBalance = "api/leaves/balance";
  static getSgpiOutReport = "api/getSgpiOutReport";
  static getRcpaSkuSummary = "api/getRcpaSkuSummary";
  static getPodReport = "api/getPodReport";
  static getJwReport = "api/getJwReport";
  static getExpensesSummary = "api/getExpensesSummary";
  static getExpenseStatus = "api/getExpenseStatus";
  static pendingAdminLeaveCountList = "api/pendingAdminLeaveCountList";
  static getMtpDayById = "api/plans/mtp/days";
  static classificationChart = "api/classificationChart";
}
